import React, { useState, useEffect } from 'react';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    HashRouter as Router,
    Switch,
    Route,
    useLocation
} from "react-router-dom";
import { Footer } from './components/Footer/Footer';
import { Header } from './components/Header/Header';
import { LoadingModal } from './components/LoadingModal/LoadingModal';
import { NotificationMessage } from './features/notification-message/NotificationMessage';
import { LoadingContext } from './providers/LoadingContext';
import { NotificationContext } from './providers/NotificationContext';
import { showMessage } from './features/notification-message/notificationMessageSlice';
import { useDispatch } from 'react-redux';
import { AppRouter } from './Router';

function scrollEvent() {
    var top = window.pageYOffset || document.documentElement.scrollTop;
    // var left = window.pageXOffset || document.documentElement.scrollLeft;
    var element = document.getElementsByTagName("nav")[0];
    if (top === 0) {
        element.classList.remove("white");
    } else if (element.classList != null) {
        element.classList.add("white");
    }
}

function ScrollToTop({ children }) {
    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname.includes("/")) window.scrollTo(0, 0);
    }, [pathname]);

    return children;
}

function App(props) {
    window.onscroll = scrollEvent;

    return (
        <div className="App">
            <NotificationMessage />
            <Header />
            <LoadingModal isLoading={props.isLoading} text={props.text} />
        </div>
    );
}

const compose = (contexts, children) =>
    contexts.reduce((acc, [Context, value]) => {
        return <Context.Provider value={value}>{acc}</Context.Provider>;
    }, children);


function AppWithContext() {
    const setLoadingText = useState("Loading...")[1];
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const showNotificationMessage = (text, color) => dispatch(showMessage({ text, color }));

    return compose([
        [LoadingContext, { setLoadingText, setIsLoading }],
        [NotificationContext, { showNotificationMessage }],
    ], <Router>
        <App isLoading={isLoading} />

        <main className="content">
            <ScrollToTop>
                <AppRouter />
            </ScrollToTop>
        </main>
        <Footer />
    </Router>);
}

export default AppWithContext;